<template>
	<div class="congrats w-100">
		<h2>
			Has llegado a la meta final, <br>
			¡felicidades! <br>
			Ahora ya sabes la ubicación de todas las teclas <br>
			en la fila básica, <br>
			la fila superior y <br>
			la fila inferior. <br> 
			¡Genial! <br>
			<AuthButton to="/three/practice" style="position: static;">Tu entreno de tecleo</AuthButton>
		</h2>
	</div>
</template>

<script>
import AuthButton from '../../../../components/AuthButton.vue'
import { setupActivityTwo } from "@/common/activities";

export default {
	components: { AuthButton },
	name: "Congrats",
	mounted: ()=> setupActivityTwo('wrapper2', 'wrapper2', '.right-to-left .series-row'),
};
</script>

<style scoped>
</style>